<div class="dashboard-container">
    <div class="dashboard-menu-view">
        <ccdl-nav-bar [navList]="navigationList" (onNavClick)="onNavigationEmitter($event)"></ccdl-nav-bar>
    </div>
    <ccdl-divider></ccdl-divider>
    <router-outlet />
</div>

